import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { getSims } from "../../../redux/slices/sims.js";
import { Container, Row, Col, Fade, Card } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import Loader from "../../../components/spinners/Loader.js";
import Single from "./SimSingle";
import SimsList from "./SimsList.js";
import { getCustomFields } from "../../../redux/slices/customFields.js";
import NotyfContext from "../../../contexts/NotyfContext.js";
import SimFiltersContext from "../../../contexts/SimFiltersContext.js";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../../hooks/useWindowSize.js";

function Sims({ demoMode = false }) {
  const dispatch = useDispatch();
  const sims = useSelector((state) => state.sims.sims);
  const count = useSelector((state) => state.sims.count);
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});
  const whitelabel = useSelector((state) => state.whitelabel.whitelabel);
  const notyf = useContext(NotyfContext);
  const { customFields } = useSelector((state) => state.customFields);
  const [open, setOpen] = useState(false);
  const [shownSim, setShownSim] = useState();
  const [singleIsShown, setSingleIsShown] = useState(false);
  const isDemoOrLead = demoMode || activeUser.role === "lead";
  const [isLoading, setIsLoading] = useState(!isDemoOrLead);
  const [numberOfRecordsRetrieved, setNumberOfRecordsRetrieved] =
    useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(0);
  const [cellInfo, setCellInfo] = useState({
    area: "",
    cell: "",
    cellId: "",
    lat: "",
    lon: "",
    mcc: "",
    range: "",
    unit: "",
  });
  const [width] = useWindowSize();
  const isDesktop = width > 768;
  // const [filters] = useState({
  //   status: "",
  //   imsi: "",
  //   iccid: "",
  //   msisdn: "",
  //   eid: "",
  //   minData: "",
  //   maxData: "",
  // });
  const { filters, setFilters, sort, setSort } = useContext(SimFiltersContext);
  const [mergedFilters, setMergedFilters] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setIsLoading(!isDemoOrLead);
  }, [isDemoOrLead]);

  const staticSimsData = [
    {
      id: 1,
      imsi: "2345***********",
      iccid: "8944**************",
      msisdn: "+3069********",
      imei: "3567***********",
      status: "Active",
      state: "Productive",
      offer: { name: "IoT Basic" },
      totalMBytes: "120",
      simType: "NextM2M SIM T2",
      ipAddress: "10.15.34.201",
      sku: "NXM2M-T2-001",
      latestCellInfo: {
        latitude: "37.9838",
        longitude: "23.7275",
        area: "3012",
        cell: "A3F4",
        range: "2500",
        unit: "0.8",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM card was activated",
          createdAt: "2025/07/01 21:00",
        },
        {
          id: 2,
          type: "SUSPEND",
          description: "SIM card was suspended",
          createdAt: "2025/07/10 10:30",
        },
        {
          id: 3,
          type: "SUSPEND",
          description: "SIM card was resumed",
          createdAt: "2025/07/11 16:45",
        },
      ],
    },
    {
      id: 2,
      imsi: "9014***********",
      iccid: "8988**************",
      msisdn: "+4477********",
      imei: "8652***********",
      status: "Suspended",
      state: "Suspended",
      offer: { name: "Global Connect" },
      totalMBytes: "300",
      simType: "Jersey Embedded Sim",
      ipAddress: "192.168.1.14",
      sku: "JER-EMB-002",
      latestCellInfo: {
        latitude: "51.5074",
        longitude: "-0.1278",
        area: "2045",
        cell: "9C2A",
        range: "1800",
        unit: "1.0",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM card was activated",
          createdAt: "2025/06/15 12:00",
        },
        {
          id: 2,
          type: "MODIFY",
          description: "SIM card was modified",
          createdAt: "2025/06/20 14:20",
        },
        {
          id: 3,
          type: "SUSPEND",
          description: "SIM card was suspended",
          createdAt: "2025/06/25 09:10",
        },
      ],
    },
    {
      id: 3,
      imsi: "2345***********",
      iccid: "8944**************",
      msisdn: "+4915********",
      imei: "0147***********",
      status: "Active",
      state: "Productive",
      offer: { name: "Fleet Plan" },
      totalMBytes: "78",
      simType: "NextM2M SIM T3",
      ipAddress: "172.16.0.8",
      sku: "NXM2M-T3-003",
      latestCellInfo: {
        latitude: "52.5200",
        longitude: "13.4050",
        area: "1120",
        cell: "7E1B",
        range: "3000",
        unit: "0.9",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM card was activated",
          createdAt: "2025/07/03 08:00",
        },
        {
          id: 2,
          type: "TERMINATE",
          description: "SIM card was terminated",
          createdAt: "2025/07/12 13:05",
        },
      ],
    },
    {
      id: 4,
      imsi: "9014***********",
      iccid: "8988**************",
      msisdn: "+3934********",
      imei: "3591***********",
      status: "Deleted",
      state: "Deleted",
      offer: { name: "Legacy Plan" },
      totalMBytes: "0",
      simType: "IoT SIM Card Industrial",
      ipAddress: "100.64.22.11",
      sku: "IOT-IND-004",
      latestCellInfo: {
        latitude: "45.4642",
        longitude: "9.1900",
        area: "3056",
        cell: "D7E2",
        range: "1500",
        unit: "0.7",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM card was activated",
          createdAt: "2024/12/01 10:00",
        },
        {
          id: 2,
          type: "SUSPEND",
          description: "SIM card was suspended",
          createdAt: "2025/01/10 11:20",
        },
        {
          id: 3,
          type: "TERMINATE",
          description: "SIM card was terminated",
          createdAt: "2025/03/05 15:30",
        },
      ],
    },
    {
      id: 5,
      imsi: "2345***********",
      iccid: "8944**************",
      msisdn: "+3365********",
      imei: "8623***********",
      status: "OnStock",
      state: "OnStock",
      offer: { name: "Global Connect" },
      totalMBytes: "0",
      simType: "IoT SIM Card Industrial",
      ipAddress: "172.20.10.3",
      sku: "IOT-IND-005",
      latestCellInfo: {
        latitude: "48.8566",
        longitude: "2.3522",
        area: "1987",
        cell: "B6C9",
        range: "2200",
        unit: "0.85",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM was activated",
          createdAt: "2025/06/01 09:00",
        },
      ],
    },
    {
      id: 6,
      imsi: "2345***********",
      iccid: "8944**************",
      msisdn: "+3519********",
      imei: "8674***********",
      status: "Active",
      state: "Productive",
      offer: { name: "EU Travel" },
      totalMBytes: "200",
      simType: "IoT SIM Chip Industrial",
      ipAddress: "192.168.100.22",
      sku: "IOT-CHIP-006",
      latestCellInfo: {
        latitude: "38.7169",
        longitude: "-9.1399",
        area: "2789",
        cell: "C4D3",
        range: "1700",
        unit: "1.2",
      },
      simActivity: [
        {
          id: 1,
          type: "ACTIVATE",
          description: "SIM card was activated",
          createdAt: "2025/05/10 18:00",
        },
      ],
    },
  ];

  useEffect(() => {
    setMergedFilters(filters);
  }, [filters]);

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    setPage(0);
    setPageSize(50);
  }, [filters]);

  useEffect(() => {
    const fetchSims = async () => {
      await Promise.all([
        dispatch(
          getSims({
            page: page + 1,
            pageSize: pageSize,
            filters: filters,
            sortField: sort.sortField,
            sortOrder: sort.sortOrder,
          })
        ),
      ])
        .then(() => {
          setNumberOfRecordsRetrieved(true);
        })
        .catch((error) => {
          notyf.open({
            type: "danger",
            message: error,
            duration: 5000,
            dismissible: false,
            ripple: true,
            position: {
              x: "center",
              y: "top",
            },
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, 5000);
        });
    };

    const fetchCustomFields = async () => {
      await dispatch(getCustomFields()).catch((error) => {
        notyf.open({
          type: "danger",
          message: error,
          duration: 5000,
          ripple: true,
          dismissible: false,
          position: {
            x: "center",
            y: "top",
          },
        });
      });
    };

    if (activeUser.id && demoMode === false && activeUser.role !== "lead") {
      fetchSims();
      if (
        activeUser.role !== "admin" &&
        (activeUser.role !== "subaccount" || activeUser.admin === null)
      ) {
        fetchCustomFields();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page, pageSize, count, activeUser]);

  useEffect(() => {
    setMergedFilters(
      customFields.reduce(
        (acc, field) => {
          acc[field.displayName.trim()] = "";
          return acc;
        },
        { ...filters }
      )
    );
  }, [customFields, filters]);

  if (isDesktop) {
    if (!isDemoOrLead && (isLoading || !numberOfRecordsRetrieved)) {
      return (
        <Card className="w-100 h-100">
          <Card.Body className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <React.Fragment>
          <Helmet title="SIMs">
            <link
              rel="icon"
              href={`${process.env.REACT_APP_POS2CLOUD_IMAGE_URL}${whitelabel?.tabImage?.imagePath}`}
            />
          </Helmet>
          <Container fluid className="p-0">
            <h1 className="h3 mb-3">{t("sims.title")}</h1>
            <Row>
              <Col
                md="12"
                xl={open ? "8" : "12"}
                style={{ transition: "all 0.5s" }}
              >
                <SimsList
                  setOpen={setOpen}
                  setSingleIsShown={setSingleIsShown}
                  shownSim={!isDemoOrLead ? shownSim : staticSimsData[0]}
                  setShownSim={setShownSim}
                  data={!isDemoOrLead ? sims.sims : staticSimsData}
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  numberOfRecords={!isDemoOrLead ? sims.pages : 1}
                  setCellInfo={setCellInfo}
                  filters={filters}
                  setFilters={setFilters}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  customFields={customFields}
                  sort={sort}
                  setSort={setSort}
                  demoMode={demoMode}
                />
              </Col>
              <Fade in={singleIsShown}>
                <Col md="12" xl="4">
                  <Single
                    setOpen={setOpen}
                    setSingleIsShown={setSingleIsShown}
                    shownSim={shownSim}
                    cellInfo={cellInfo}
                    page={page}
                    pageSize={pageSize}
                    filters={mergedFilters}
                    clearSelectedRows={() => setSelectedRows([])}
                    demoMode={demoMode}
                  />
                </Col>
              </Fade>
            </Row>
          </Container>
        </React.Fragment>
      );
    }
  } else {
    if (!isDemoOrLead && (isLoading || !numberOfRecordsRetrieved)) {
      return (
        <Card className="w-100 h-100">
          <Card.Body className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <React.Fragment>
          <Helmet title="SIMs">
            <link
              rel="icon"
              href={`${process.env.REACT_APP_POS2CLOUD_IMAGE_URL}${whitelabel?.tabImage?.imagePath}`}
            />
          </Helmet>
          <Container fluid className="p-0">
            <h1 className="h3 mb-3">{t("sims.title")}</h1>
            <SimsList
              setOpen={setOpen}
              setSingleIsShown={setSingleIsShown}
              shownSim={!isDemoOrLead ? shownSim : staticSimsData[0]}
              setShownSim={setShownSim}
              data={!isDemoOrLead ? sims.sims : staticSimsData}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              numberOfRecords={!isDemoOrLead ? sims.pages : 1}
              setCellInfo={setCellInfo}
              filters={filters}
              setFilters={setFilters}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              customFields={customFields}
              sort={sort}
              setSort={setSort}
              demoMode={demoMode}
            />
            <Single
              open={open}
              setOpen={setOpen}
              setSingleIsShown={setSingleIsShown}
              shownSim={shownSim}
              cellInfo={cellInfo}
              page={page}
              pageSize={pageSize}
              filters={mergedFilters}
              clearSelectedRows={() => setSelectedRows([])}
            />
          </Container>
        </React.Fragment>
      );
    }
  }
}

export default Sims;
